export default "__VITE_ASSET__DNPlZSYt__"